<template>
  <ul class="nav nav-mobile-menu">
    <li v-if="isAuth" class="nav-item">
      <a class="nav-link" href="#">
        <span class="no-icon" @click.prevent="logout">Log out</span>
      </a>
    </li>
    <li v-else class="nav-item">
      <sidebar-link class="nav-link" to="/login">
        <span class="no-icon">Log in</span>
      </sidebar-link>
    </li>
  </ul>
</template>
<script>
  export default {
    components: {
    },
    computed: {
      isAuth () {
        return this.$root.isAuth
      }
    },
    methods: {
      logout () {
        this.$root.logout()
        this.hideSidebar()
      },
      hideSidebar () {
        if (this.$sidebar && this.$sidebar.showSidebar === true) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/MobileMenu.vue